import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixDialog from "@radix-ui/react-dialog";
import { memo } from "react";
import { ActionSheetContent } from "./ActionSheetContent";
import { ActionSheetOverlay } from "./ActionSheetOverlay";
export const ActionSheet = /*#__PURE__*/ memo((param)=>{
    let { onClose, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixDialog.Root, {
        open: true,
        onOpenChange: onClose,
        children: /*#__PURE__*/ _jsxs(RadixDialog.Portal, {
            children: [
                /*#__PURE__*/ _jsx(ActionSheetOverlay, {}),
                /*#__PURE__*/ _jsx(ActionSheetContent, {
                    onClose: onClose,
                    ...restOfProps
                })
            ]
        })
    });
});
ActionSheet.displayName = "ActionSheet";
